import React from "react";
import { Box, Typography } from "@mui/material";

export const FIRST_CO_APPLICANT_EMPLOYMENT_MESSAGE =
  "Add 1st co-applicant for whom you want to upload documents for loan.";

export const getEmploymentCoApplicantNumber = (fieldName?: string) =>
  String(fieldName || "").match(/^employmentCoApplicant(\d+)/i)?.[1] || "";

export const isFirstCoApplicant = (coApplicantNumber?: string | number | null) =>
  String(coApplicantNumber || "") === "1";

export const isFirstCoApplicantEmploymentField = (fieldName?: string) =>
  isFirstCoApplicant(getEmploymentCoApplicantNumber(fieldName)) &&
  /^employmentCoApplicant1(?:employment)?isEmployed$/i.test(String(fieldName || ""));

export const lockFirstCoApplicantEmploymentField = (field: any) =>
  isFirstCoApplicantEmploymentField(field?.name || field?.key)
    ? { ...field, value: "Yes", disabled: true }
    : field;

export const ensureFirstCoApplicantEmploymentYes = (
  formikRef: any,
  fieldName = "employmentCoApplicant1isEmployed",
) => {
  if (
    formikRef?.current?.values &&
    isFirstCoApplicantEmploymentField(fieldName) &&
    formikRef.current.values[fieldName] !== "Yes"
  ) {
    formikRef.current.values[fieldName] = "Yes";
  }
};

export const FirstCoApplicantEmploymentNotice = () => (
  <Box
    sx={{
      backgroundColor: "#fff8e1",
      border: "1px solid #ffb74d",
      borderRadius: "6px",
      display: "block",
      px: 2,
      py: 1.5,
      mb: 2.5,
      width: "100%",
      boxSizing: "border-box",
    }}
  >
    <Typography
      sx={{
        fontSize: "13px",
        fontWeight: 400,
        color: "rgba(0, 0, 0, 0.6)",
        fontFamily: 'Jost, "Helvetica Neue", Arial, sans-serif',
        lineHeight: "20px",
      }}
    >
      {FIRST_CO_APPLICANT_EMPLOYMENT_MESSAGE}
    </Typography>
  </Box>
);
